import type { PushSdkInternals } from '../push-sdk-internal-impl'
import type { PromptDispatchMessage } from '../types/prompt-dispatch-message.ts'
import { type Logger, TaggedLogger } from '@core/logging/logger'

/** @internal */
export type Prompts = {
    /**
     * Dispatches messages from a displayed Prompt element
     * to the SDK {@link PromptsController}.
     */
    dispatch(message: PromptDispatchMessage): Promise<void>
}

/** @internal */
export class PromptsImpl implements Prompts {
    // @ts-ignore -- unused
    readonly #sdk: PushSdkInternals
    readonly #logger: Logger

    public constructor(sdk: PushSdkInternals, logger?: Logger) {
        this.#sdk = sdk
        this.#logger = logger ?? TaggedLogger._getInstance('Prompts')
    }

    public async dispatch(message: PromptDispatchMessage): Promise<void> {
        if (!message.prompt_action) {
            this.#logger.debug('Received unknown Prompt message:', message)
            return
        }

        await this.#sdk.promptsController?._processDispatchMessage(message)
    }
}
